import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=cbb4d58e&scoped=true&"
import script from "./Agency.vue?vue&type=script&lang=ts&"
export * from "./Agency.vue?vue&type=script&lang=ts&"
import style0 from "./Agency.vue?vue&type=style&index=0&id=cbb4d58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb4d58e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
